<section class="academy-section" id="accompagnement">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Accompagnement complet</span>
      <h2>Bien plus qu'un outil, un écosystème complet</h2>
      <p>Formation, support expert et revenus additionnels</p>
    </div>
    <div class="academy-grid-top">
      <div class="academy-card-compact">
        <div class="academy-icon-compact">🎓</div>
        <h3>Wealthlane Academy</h3>
        <p>Fiches patrimoniales, vidéos interactives et certification professionnelle pour maîtriser le conseil patrimonial.</p>
        <div class="academy-badge">Formation incluse</div>
      </div>
      <div class="academy-card-compact">
        <div class="academy-icon-compact">🤝</div>
        <h3>Support expert 24/7</h3>
        <p>Cellule d'ingénierie patrimoniale dédiée pour vous accompagner sur les cas complexes.</p>
        <div class="academy-badge">Assistance permanente</div>
      </div>
      <div class="academy-card-compact">
        <div class="academy-icon-compact">💰</div>
        <h3>Commissions produits</h3>
        <p>Générez 1% de commission sur chaque produit souscrit directement depuis la plateforme.</p>
        <div class="academy-badge">Revenus passifs</div>
      </div>
    </div>

    <div class="revenue-showcase">
      <div class="revenue-showcase-header">
        <div class="showcase-icon">💸</div>
        <div>
          <h3>Exemple de revenus cumulés sur une mission</h3>
          <p>Maximisez vos revenus en cumulant conseil et commissions</p>
        </div>
      </div>
      <div class="revenue-breakdown">
        <div class="revenue-item">
          <div class="revenue-label">Bilan patrimonial vendu</div>
          <div class="revenue-amount">2 000€</div>
        </div>
        <div class="revenue-plus">+</div>
        <div class="revenue-item">
          <div class="revenue-label">Commission assurance-vie (500k€ × 1%)</div>
          <div class="revenue-amount">5 000€</div>
        </div>
        <div class="revenue-equals">=</div>
        <div class="revenue-item revenue-total-item">
          <div class="revenue-label">Total mission</div>
          <div class="revenue-amount-total">7 000€</div>
        </div>
      </div>
    </div>
  </div>
</section>

